import { render, staticRenderFns } from "./GalleryGrid.vue?vue&type=template&id=72af281d"
import script from "./GalleryGrid.vue?vue&type=script&lang=js"
export * from "./GalleryGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports